<template>
  <div class="Shape" v-bind:style="{ marginTop: marginTopPos }">
    <v-row>
      <v-col>
        <GmapMap
          :center="posCenter"
          :zoom="20"
          style="width: 100%; height: 100%"
          ref="mapRef"
          @dragend="handleDrag"
        >
          <gmap-info-window
            :options="infoOptions"
            :position="infoPosition"
            :opened="infoOpened"
            @closeclick="infoOpened = false"
          >
            <h2>{{ infoContent }}</h2>
            <hr />
            <h3>
              <div>PT Indo Fin Tek</div>
              <div>
                Gedung Mutiara Building
                Lt. 2 - Unit 205
                Jl. Mampang Prapatan Raya No. 10
                Jakarta Selatan, DKI Jakarta 12790
              </div>
              <!-- <div>Jl. Sungai Gerong No.1A Jakarta Pusat, 10230.</div> -->
            </h3>
          </gmap-info-window>
          <gmap-marker
            :key="index"
            v-for="(m, index) in markers"
            :position="m.position"
            @click="toggleInfo(m, index)"
          ></gmap-marker>
        </GmapMap>
      </v-col>
      <v-col>
        <p class="title-1">Send us a Message</p>
        <v-row>
          <v-col>
            <div class="Indosurya-Plaza-Penthouse-Floor-Jalan-MH-Thamri">
              <div>PT Indo Fin Tek</div>
              <div>
                Gedung Mutiara Building
                Lt. 2 - Unit 205
                Jl. Mampang Prapatan Raya No. 10
                Jakarta Selatan, DKI Jakarta 12790
              </div>
              <!-- <div>Jl. Sungai Gerong No.1A Jakarta Pusat, 10230.</div> -->
            </div>
          </v-col>
          <v-col>
            <p class="e-mail">cs@dompetkilat.co.id</p>
            <p class="no-telp">(021) 3193-4699</p>
          </v-col>
        </v-row>
        <div class="Name-Input">
          <p class="Name-Title">Your Name</p>
          <v-text-field
            class="input-field"
            style="width: 442px"
            v-model="name"
            placeholder="Nama Anda"
          />
        </div>
        <div class="Email-Input">
          <p class="Name-Title">Email Address</p>
          <v-text-field
            class="input-field"
            v-model="email"
            placeholder="Email Anda"
          />
        </div>
        <div class="Message-Input">
          <p class="Name-Title">Message</p>
          <v-textarea
            rows="3"
            class="input-field"
            v-model="message"
            placeholder="Halo..."
          />
        </div>
        <v-btn
          @click="kirimpesan()"
          color="black"
          rounded
          block
          dark
          class="Shape-Button-Text"
          ><p style="margin: 0px">Kirim Pesan</p></v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // default to montreal to keep it simple
      // change this to whatever makes sense
      posCenter: { lat: -6.198348437702837, lng: 106.82281486916023 },
      markers: [
        {
          full_name: "DompetKilat",
          position: { lat: -6.198348437702837, lng: 106.82281486916023 },
        },
      ],
      infoPosition: null,
      infoContent: null,
      infoOpened: false,
      infoCurrentKey: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      map: null,
      currentPlace: null,
      name: "",
      email: "",
      message: "",
      marginTopPos: "-" + window.innerWidth / 10 + "px",
    };
  },

  mounted() {
    this.$refs.mapRef.$mapPromise.then((map) => {
      this.map = map;
    });
  },
  created() {
    window.addEventListener("resize", this.myEventHandler);
  },
  computed: {
    mapCoordinates() {
      if (!this.map) {
        return {
          iat: 0,
          lng: 0,
        };
      }
      return {
        iat: this.map.getCenter().lat().toFixed(4),
        lng: this.map.getCenter().lng().toFixed(4),
      };
    },
  },

  methods: {
    handleDrag() {
      let center = {
        lat: this.map.getCenter().lat(),
        lng: this.map.getCenter().lng(),
      };

      let zoom = this.map.getZoom();

      localStorage.center = JSON.stringify(center);
      localStorage.zoom = zoom;
    },
    toggleInfo: function (marker, key) {
      this.infoPosition = marker.position;
      this.infoContent = marker.full_name;
      if (this.infoCurrentKey == key) {
        this.infoOpened = !this.infoOpened;
      } else {
        this.infoOpened = true;
        this.infoCurrentKey = key;
      }
    },
    kirimPesan() {
      // axios('http://localhost:3000/kirim', {name: this.name, email:this.email, message: this.message})
      // .then(() => {
      console.log("selesai");
      // })
      // .catch((err) => console.log(err)
    },
    myEventHandler() {
      // console.log(e);
      this.marginTopPos = "-" + window.innerWidth / 10 + "px";

      // your code for handling resize...
    },
  },
};
</script>
<style scoped>
.Shape {
  width: 895px;
  height: 524px;
  margin: -793px auto 0px auto;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  position: relative;
}
.title-1 {
  width: 175px;
  height: 24px;
  flex-grow: 0;
  margin: 0 8px 12px 0;
  font-family: Sora;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.Indosurya-Plaza-Penthouse-Floor-Jalan-MH-Thamri {
  width: 163px;
  height: 80px;
  flex-grow: 0;
  margin: 12px 20px 100px 0;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: 0.28px;
  text-align: left;
  color: #767676;
}
.e-mail {
  width: 159px;
  height: 21px;
  flex-grow: 0;
  margin: 12px 0 8px 8px;
  font-family: Inter;
  font-size: 13px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: 0.26px;
  text-align: left;
  color: #767676;
}
.no-telp {
  width: 159px;
  height: 21px;
  flex-grow: 0;
  margin: 8px 0 44px 8px;
  font-family: Inter;
  font-size: 13px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: 0.26px;
  text-align: left;
  color: #767676;
}
.input {
  width: 109px;
  height: 17px;
  flex-grow: 0;
  margin: 8px 233px 13px 0;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.Name-Title {
  width: 109px;
  height: 16px;
  flex-grow: 0;
  margin: 0 273px 8px 0;
  font-family: Inter;
  font-size: 13px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #b5b5b5;
}
.Name-Input {
  width: 400px;
  height: 55px;
  flex-grow: 0;
  margin: 8px 0;
}
.Email-Input {
  width: 400px;
  height: 55px;
  flex-grow: 0;
  margin: 20px 0;
}
.Message-Input {
  width: 400px;
  height: 106px;
  flex-grow: 0;
  margin: 20px 0 44px;
}
.Shape-Button {
  width: 342px;
  height: 44px;
  flex-grow: 0;
  margin-top: -10px;
  padding: 14px 133px;
  border-radius: 40px;
  box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.05);
  background-color: #252525;
}
.Shape-Button-Text {
  flex-grow: 0;
  font-family: Inter;
  margin-top: -30px;
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}
.input-field {
  flex-grow: 0;
  padding-top: 0px;
  margin: 0px;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
</style>
